import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SlidersHorizontal } from "lucide-react";

const StoreFilter = ({ stores, value, onChange }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="h-9 w-72 bg-white text-sm" data-testid="dashboard-filter-store"><SelectValue /></SelectTrigger>
    <SelectContent>
      <SelectItem value="all" data-testid="dashboard-filter-store-all">All stores ({stores.length})</SelectItem>
      {stores.map((s) => (
        <SelectItem key={s.door_tsp} value={s.door_tsp} data-testid={`dashboard-filter-store-${s.door_tsp}`}>
          {s.location?.name?.replace("Total Wireless | ", "") || `${s.city}, ${s.state}`} · {s.store_id}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export const DashboardFilterBar = ({ stores, filters, onChange }) => (
  <div className="flex items-center gap-3 flex-wrap bg-slate-50 border border-slate-200 rounded-xl px-4 py-2.5" data-testid="dashboard-filter-bar">
    <span className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500"><SlidersHorizontal className="w-4 h-4 text-teal" /> Filters</span>
    <StoreFilter stores={stores} value={filters.store} onChange={(v) => onChange({ ...filters, store: v })} />
  </div>
);
